export default __webpack_public_path__ + "static/img/18.60e5cbf.png";